import _ from 'lodash';

// Global Mixin(s):
import Toast from '@mixins/Toast/Toast.js'; // eslint-disable-line

/**
 * Created By: Tyrus Malmstrom
 * Creation Date: 03/30/2022
 * Description:
 *   - Mixin to house specific functionality for our modals (more modern Popover).
*/
export default {
  data() {
    return {
      options: {
        title: 'Insert title here',
        text: 'Insert modal text here.',
        icon: 'success',
        showCancelButton: true,
        showCloseButton: true, // 'x' in the top right
        showConfirmButton: true,
        confirmButtonColor: this.$vuetify.theme.primary,
        cancelButtonColor: this.$vuetify.theme.secondary,
      },
    };
  },
  mixins: [Toast],
  methods: {
    openModal(modalOptions = {}) {
      const finalOptions = _.merge(this.options, modalOptions);
      this.$swal.fire({
        title: finalOptions.title,
        text: finalOptions.text,
        icon: finalOptions.icon,
        applicationContext: _.has(finalOptions, 'applicationContext') ? finalOptions.applicationContext : 'root',
        allowEscapeKey: _.has(finalOptions, 'allowEscapeKey') ? finalOptions.allowEscapeKey : true,
        backdrop: _.has(finalOptions, 'backdrop') ? finalOptions.backdrop : true,
        iconColor: _.has(finalOptions, 'iconColor') ? finalOptions.iconColor : this.$vuetify.theme.primary,
        confirmButtonText: _.has(finalOptions, 'confirmButtonText') ? finalOptions.confirmButtonText : 'OK',
        allowOutsideClick: _.has(finalOptions, 'allowOutsideClick') ? finalOptions.allowOutsideClick : true,
        showCancelButton: finalOptions.showCancelButton,
        html: _.has(finalOptions, 'html') ? finalOptions.html : '',
        cancelButtonText: _.has(finalOptions, 'cancelButtonText') ? finalOptions.cancelButtonText : 'Cancel',
        width: _.has(finalOptions, 'width') ? finalOptions.width : '32em',
        showCloseButton: finalOptions.showCloseButton,
        showConfirmButton: finalOptions.showConfirmButton,
        confirmButtonColor: finalOptions.confirmButtonColor,
        imageUrl: _.has(finalOptions, 'imageUrl') ? finalOptions.imageUrl : '',
        padding: _.has(finalOptions, 'padding') ? finalOptions.padding : '0 0 1.25em',
        imageHeight: _.has(finalOptions, 'imageHeight') ? finalOptions.imageHeight : '0',
        imageWidth: _.has(finalOptions, 'imageWidth') ? finalOptions.imageWidth : '0',
        buttonsStyling: _.has(finalOptions, 'buttonsStyling') ? finalOptions.buttonsStyling : true,
        focusConfirm: _.has(finalOptions, 'focusConfirm') ? finalOptions.focusConfirm : true,
        focusCancel: _.has(finalOptions, 'focusCancel') ? finalOptions.focusCancel : false,
        cancelButtonColor: finalOptions.cancelButtonColor,
        customClass: _.has(finalOptions, 'customClass') ? finalOptions.customClass : {},
        showClass: _.has(finalOptions, 'showClass') ? finalOptions.showClass : {},
        hideClass: _.has(finalOptions, 'hideClass') ? finalOptions.hideClass : {},
        ...(_.isFunction(finalOptions.didOpen) && { didOpen: finalOptions.didOpen.bind(this) }),
        ...(_.isFunction(finalOptions.willClose) && { willClose: finalOptions.willClose.bind(this) }),
      }).then((result) => {
        if (result.isConfirmed) {
          finalOptions.callback();
          if (finalOptions.applicationContext === 'discussionActions') {
            setTimeout(() => {
              this.fireToast({
                icon: 'success',
                iconColor: this.$vuetify.theme.primary,
                position: 'top-end',
                title: 'Comment successfully deleted!',
                customClass: {
                  title: 'playposit-player-toast',
                },
              });
            }, 1100);
          }
        }
        if (
          [
            this.$swal.DismissReason.esc,
            this.$swal.DismissReason.backdrop,
            this.$swal.DismissReason.close,
          ].includes(result.dismiss)
          && finalOptions.applicationContext === 'wevideoAnnouncement'
        ) {
          finalOptions.callback();
        }
      });
    },
  },
};
